import { InjectionToken } from "@angular/core";
import { HealthChecker } from "./health-checker";

export const HEALTH_CHECKERS = new InjectionToken<HealthChecker[]>('HEALTH_CHECKERS');
